import { AxiosResponse } from 'axios';
import { IngredientCreateDto } from '~/src/types/ingredientCreateDto';
import { IngredientEditDto } from '~/src/types/ingredientEditDto';
import { IngredientGetDto } from '~/src/types/ingredientGetDto';
import { IngredientResultDto } from '~/src/types/ingredientResultDto';
import { ProcessIngredientsDto } from '~/src/types/processIngredientsDto';

import { API_URL } from '../../utils/constants';
import KendoService from '../logic/KendoService';
import request from '../request';

export default {
  calculateRemotely: async (data: any): Promise<AxiosResponse<IngredientGetDto>> => {
    const body = JSON.stringify(data);
    return request(`https://hexakit.com/nutricalc`, 'post', body);
  },

  getRemotely: async (id: string): Promise<AxiosResponse<IngredientGetDto>> => {
    return request(`https://hexakit.com/nutrisult/${id}`, 'get');
  },

  getOrCreateForProduct: async (id: string): Promise<AxiosResponse<IngredientGetDto>> => {
    return request(`${API_URL}/ingredients/get-or-create-for-product/${id}`, 'post');
  },

  createIngredient: async ({ name }: IngredientCreateDto): Promise<AxiosResponse<IngredientGetDto>> => {
    return request(`${API_URL}/ingredients/get-or-create-by-name`, 'post', name, {});
  },

  getIngredient: async (id: string): Promise<AxiosResponse<IngredientGetDto>> => {
    return request(`${API_URL}/ingredients/${id}`, 'get');
  },

  updateIngredient: async (id: string, values: IngredientEditDto): Promise<AxiosResponse<IngredientGetDto>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/ingredients/${id}`, 'put', body);
  },

  processIngredients: async (
    id: string,
    values: ProcessIngredientsDto,
  ): Promise<AxiosResponse<IngredientGetDto[]>> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/ingredients/process-ingredients/${id}`, 'post', body);
  },

  saveResults: async (id: string, values: IngredientResultDto[]): Promise<AxiosResponse> => {
    const body = JSON.stringify(values);
    return request(`${API_URL}/ingredients/save-results/${id}`, 'post', body);
  },

  search: async (q: string): Promise<AxiosResponse<IngredientGetDto[]>> => {
    const filters = KendoService.buildFilter(['name'], q);
    const values = {
      filter: {
        filters,
        logic: 'or',
      },
      take: 100,
      skip: 0,
    };

    const body = JSON.stringify(values);
    return request(`${API_URL}/ingredients/get`, 'post', body);
  },

  export: async (ParentIngredientId: string) => {
    return request(`${API_URL}/ingredients/export-results/${ParentIngredientId}`, 'get', null, null, {
      responseType: 'arraybuffer',
    });
  },
};
